export const REPO_GITHUB_URL = "https://github.com/arxanas/smashtraining";

export const REPO_GITHUB_ISSUES_URL =
  "https://github.com/arxanas/smashtraining/issues/new";

export const REPO_GITHUB_RELEASES_API_URL =
  "https://api.github.com/repos/arxanas/smashtraining/releases/latest";

export const CONTACT_HREF = "mailto:me@waleedkhan.name";

export const PATREON_URL = "https://www.patreon.com/arxanas";
